import { exportExcelApi } from "services/dashboard";
import { downloadFile } from "utils/commonFun";
import { failMessage } from "utils/toastMessage";

export const exportBill = async (selectedSite = {}, setLoading = () => { }) => {
    if (selectedSite?._id) {
        try {
            setLoading(true)
            const res = await exportExcelApi({
                plantId: selectedSite?._id,
            });
            if (res?.status === 200) {
                downloadFile(res?.data?.url)
            } else {
                failMessage(res)
            }
        } catch (e) {
            console.log('error', e?.message)
        } finally {
            setLoading(false)
        }
    }
}